<template>
  <div class="page-container flex flex-col">
    <a-card>
      <a-form @keyup.enter.native="getFile" layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="日期">
              <j-date style="width: 100%" v-model="date" @change="getFile" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="getFile" icon="search">查询</a-button>
              <a-button @click="exportXls" icon="download" style="margin-left: 8px">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <!-- 查询区域-END -->

    <!-- 报表区域 -->
    <div :class="['flex-1']">
      <iframe-f-report-view
        :mozallowfullscreen="true"
        :msallowfullscreen="true"
        :oallowfullscreen="true"
        :src="fileViewUrl"
        height="100%"
        allowfullscreen="true"
        frameborder="0"
        ref="commentIframe"
        webkitallowfullscreen="true"
      ></iframe-f-report-view>
    </div>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import IframeFReportView from '@/components/layouts/IframeFReportView.vue'
import moment from 'dayjs'

export default {
  name: 'FileReport',
  components: {
    IframeFReportView
  },
  data() {
    return {
      description: '在线报表管理页面',
      url: {
        list: '/custom/commonOnlReport/list',
        delete: '/custom/commonOnlReport/delete',
        deleteBatch: '/custom/commonOnlReport/deleteBatch',
        exportXlsUrl: '/custom/commonOnlReport/exportXls',
        importExcelUrl: 'custom/commonOnlReport/importExcel'
      },
      date: '',
      paramUrl: '',
      fileUrl: '',
      fileViewUrl: ''
    }
  },
  created() {
    this.date = moment().format('YYYY-MM-DD')
    this.paramUrl = this.$route.query.fileurl
    this.getFile()
  },
  methods: {
    getFile() {
      this.fileUrl = this.paramUrl.replace('${date}', this.date)
      this.fileViewUrl = this.getPreviewUrl(this.fileUrl)
    },
    getPreviewUrl(fileUrl) {
      const buf = Buffer.from(fileUrl)
      let url = window._CONFIG['onlinePreviewDomainURL'] + '?url=' + encodeURIComponent(buf.toString('base64'))
      return url
    },
    exportXls() {
      window.open(this.fileUrl)
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

.page-container {
  height: 100%;
}

</style>
